// extracted by mini-css-extract-plugin
export var addToCartButton = "_p4-b";
export var arrowButtonContainer = "_p4-9";
export var arrowButtonIcon = "_p4-a";
export var carouselArrowButton = "_p4-6";
export var carouselElementContainer = "_p4-1";
export var left = "_p4-7";
export var productDisplayCarouselContainer = "_p4-0";
export var productTileContainer = "_p4-2";
export var productTileImage = "_p4-4";
export var productTileImageContainer = "_p4-3";
export var productTileTitle = "_p4-5";
export var right = "_p4-8";
export var sliderOverflow = "_p4-c";